<template>
   <v-container fluid>
      <v-row class="pt-3">
         <v-col cols="12">
            <v-toolbar dense color="primary white--text" bottom>
               <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                  View CCA Log
               </v-toolbar-title>
               <v-icon color="white" v-else>mdi-text-box-outline</v-icon>
            </v-toolbar>
            <v-card class="pt-2">
               <v-row>
                  <v-col cols="6" md="2" class="px-4">
                     <datepicker-dialog
                        labelname="Start Date"
                        indate.sync="filter_startdate"
                        @return-date="saveStartDate"
                     ></datepicker-dialog>
                  </v-col>
                  <v-col cols="6" md="2" class="px-4">
                     <datepicker-dialog
                        class="mx-2 px-2 pt-10"
                        labelname="End Date"
                        indate.sync="filter_enddate"
                        @return-date="saveEndDate"
                     ></datepicker-dialog>
                  </v-col>
                  <v-col cols="6" md="3" class="px-5">
                     <v-text-field
                        label="Student"
                        append-icon="mdi-account"
                        v-model="selectedstudent_name"
                        @click:append.stop="studentlistdlg = true"
                        readonly
                     ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="3" class="px-5">
                     <v-text-field
                        label="CCA Group"
                        append-icon="mdi-folder"
                        v-model="selectedccagroup_name"
                        @click:append.stop="ccalistdlg = true"
                        readonly
                     >
                     </v-text-field>
                  </v-col>
                  <v-col cols="6" md="2" align-self="center">
                     <v-btn small outlined color="indigo" class="ma-1" @click="loadCCALog"
                        >Apply Filter
                     </v-btn>
                     <v-btn class="ma-1" small outlined color="indigo" @click="resetFilter"
                        >Reset
                     </v-btn>
                  </v-col>
               </v-row>
            </v-card>
            <v-sheet height="55vh" class="over-flow-y pt-5">
               <v-data-table
                  dense
                  class="px-3"
                  height="55vh"
                  fixed-header
                  :headers="log_headers"
                  :items="logdata"
                  @click:row="logTableRowClick"
                  item-key="id"
                  :single-select="true"
               >
               </v-data-table>
            </v-sheet>
         </v-col>
      </v-row>
      <student-list
         :year="year"
         :gender="gender"
         :data="emptyarray"
         :dialogvisible.sync="studentlistdlg"
         :singleselect="true"
         :showselect="false"
         @cancel-selection="studentlistdlg = false"
         @save-selection="onSaveStudentSelection"
      >
      </student-list>
      <cca-list
         :dialogvisible.sync="ccalistdlg"
         @cancel-selection="ccalistdlg = false"
         @save-selection="onSaveCCASelection"
      >
      </cca-list>
      <show-toast ref="toast"></show-toast>
   </v-container>
</template>

<script>
   import DatepickerDialog from "@/components/DatepickerDialog.vue";
   import StudentList from "@/components/StudentList.vue";
   import CCAList from "@/components/CCAList.vue";
   import {GroupConst} from "@/common/constant.js";
   import ShowToast from "@/components/showToast.vue";

   export default {
      components: {
         DatepickerDialog,
         StudentList,
         ShowToast,
         "cca-list": CCAList,
      },

      inject: ["ShowMessage"],

      data() {
         return {
            log_headers: [
               {
                  text: "Log Date",
                  value: "logdate",
                  width: "15%",
                  class: [this.$globalstore.table_smallheaderclass],
               },
               {
                  text: "Module",
                  value: "module",
                  width: "10%",
                  class: [this.$globalstore.table_smallheaderclass],
               },
               {
                  text: "Action",
                  value: "action",
                  width: "12%",
                  class: [this.$globalstore.table_smallheaderclass],
               },
               {
                  text: "Remarks",
                  value: "remarks",
                  width: "30%",
                  class: [this.$globalstore.table_smallheaderclass],
               },
               {
                  text: "Group",
                  value: "cca_name",
                  width: "15%",
                  class: [this.$globalstore.table_smallheaderclass],
               },
               {
                  text: "User",
                  value: "user_name",
                  width: "15%",
                  class: [this.$globalstore.table_smallheaderclass],
               },
            ],
            logdata: [],

            filter_startdate: "",
            filter_enddate: "",
            emptyarray: [],
            year: GroupConst.yearselect,
            gender: null,
            studentlistdlg: false,
            ccalistdlg: false,
            selectedccagroup: null,
            selectedccagroup_name: "",
            selectedstudent: null,
            selectedstudent_name: "",
         };
      },
      methods: {
         todayDate() {
            return this.$globalstore.currentDateISOString().substr(0, 10);
         },

         logTableRowClick(item, row) {
            row.select(!row.isSelected);
         },

         resetFilter() {
            this.selectedstudent = null;
            this.selectedccagroup = null;
            this.selectedstudent_name = "";
            this.selectedccagroup_name = "";
            this.logdata = [];
         },

         saveStartDate(date) {
            this.filter_startdate = date;
         },

         saveEndDate(date) {
            this.filter_enddate = date;
         },

         onSaveStudentSelection(data) {
            this.studentlistdlg = false;
            this.selectedstudent = data[0];
            this.selectedstudent_name = this.selectedstudent.fullname;
         },

         onSaveCCASelection(data) {
            this.ccalistdlg = false;
            this.selectedccagroup = data;
            this.selectedccagroup_name = data.cca_name;
         },

         loadCCALog() {
            const sd = new Date(this.filter_startdate);
            const ed = new Date(this.filter_enddate);
            if (sd > ed) {
               this.ShowMessage({
                  title: "Error",
                  message: "End date must be greater than start date.",
                  color: "red",
               });
            } else {
               this.doGetCCALog();
            }
         },

         async doGetCCALog() {
            await this.$http({
               url: "/cca/getccalog.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  startdate: this.filter_startdate,
                  enddate: this.filter_enddate,
                  school_id: this.selectedstudent ? this.selectedstudent.school_id : null,
                  cca_id: this.selectedccagroup ? this.selectedccagroup.cca_id : null,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     if (response.data.logdata.length === 0) {
                        this.$refs.toast.display({
                           message: "No logs found for specified criteria.",
                           color: "primary",
                        });
                     } else {
                        this.logdata = response.data.logdata;
                     }
                  }
               }
            });
         },
      },

      mounted() {
         // set gender selection to co-ed id
         if (this.$globalstore && this.$globalstore.appready) {
            this.gender = this.$globalstore.gender_select.find((x) => x.id === 2);
            this.filter_startdate = this.todayDate();
            this.filter_enddate = this.todayDate();
         }
      },
   };
</script>
